import { render } from "./ShareProposal.vue?vue&type=template&id=5df68093&scoped=true"
import script from "./ShareProposal.vue?vue&type=script&lang=js"
export * from "./ShareProposal.vue?vue&type=script&lang=js"

import "./ShareProposal.vue?vue&type=style&index=0&id=5df68093&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5df68093"]])

export default __exports__